import styled from "styled-components";
import { FlexColumn, FlexRow } from "styles/layout";

export const FiltersContainer = styled(FlexColumn)`
  row-gap: 20px;
  width: 100%;
`;

export const FilterRow = styled(FlexRow)`
  column-gap: 50px;
  flex-wrap: wrap;
`;

export const FilterContainer = styled(FlexColumn)``;
export const ToggleFilterContainer = styled(FilterContainer)`
  width: 100%;
`;

export const FilterHeader = styled.div`
  margin-bottom: 4px;
  font-weight: 500;
  font-size: 11.5pt;

  @media (max-width: 700px) {
    font-size: 11pt;
  }
`;
